'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useOrderStore } from '@/store/useOrderStore';
import { useAdminMode } from '@/hooks/useAdminMode';
import { cn } from '@/lib/utils';
import Step1CustomUpload from './Step1CustomUpload';

interface Props {
  onComplete: () => void;
}

export default function Step1QuoteInquiry({ onComplete }: Props) {
  const { itemInfo, phone } = useOrderStore();
  const { isAdmin } = useAdminMode();
  const [attempted, setAttempted] = useState(false);

  const isPhoneValid = /^01[016789]-\d{3,4}-\d{4}$/.test(phone);
  const hasContent =
    itemInfo.isCustom &&
    itemInfo.customData &&
    (itemInfo.customData.imageUrls.length > 0 || itemInfo.customData.linkUrl);
  const hasDescription = !!itemInfo.customData?.description?.trim();

  const isValid = hasContent && hasDescription && isPhoneValid;

  const handleNext = () => {
    if (!isAdmin && !isValid) {
      setAttempted(true);
      return;
    }
    onComplete();
  };

  return (
    <div className="space-y-4">
      <Step1CustomUpload attempted={attempted} />
      <Button
        onClick={handleNext}
        className={cn('w-full', !isAdmin && !isValid && 'bg-gray-300 hover:bg-gray-400 text-gray-700')}
        size="lg"
      >
        다음으로
      </Button>
    </div>
  );
}
